import { createFileRoute } from '@tanstack/react-router';
import { MyApprovalPage } from '@/features/action-approvals/pages/my-approval-page';

type Search = { focus?: string };

export const Route = createFileRoute('/_app/me/approval')({
  validateSearch: (s: Record<string, unknown>): Search => ({
    focus: typeof s.focus === 'string' ? s.focus : undefined,
  }),
  component: MyApprovalPage,
});
